import React from 'react'
import { Container, Breadcrumb, Meta, User, FormRow } from '../../../components'
import { useViewport, viewportBreakpoint } from '../../../utils'
import { useLocation } from 'react-router-dom'
import { ShareButtons } from './share-buttons'
// import { ActionButtons } from './action-buttons'

const routes = [
  {
    name: 'Home',
    route: '/'
  },
  {
    name: 'Resources',
    route: '/resource'
  },
  {
    name: 'Experts',
    route: '/resource/expert'
  }
]

const TypeExpert = ({data}) => {
  const location = useLocation()
  const special = location.search.includes('special')
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet
  const imageWidth = '100%'
  const height = isMobile ? '335px' : '470px'
  const {
    image,
    title,
    organization,
    content,
    email,
    expertise,
    phone
  } = data

  return (
    <Container className="py-5 pb-8 lg:pb-20 lg:py-20" color="#f5f5f5">
      <div className="flex flex-wrap -mx-4">
        <div className="w-full lg:w-5/12 mb-5 lg:mb-0 px-4">
          <div
            style={{width: imageWidth, height: height, backgroundImage: `url('${image}')`}}
            className="bg-no-repeat bg-cover bg-center rounded"
          />
        </div>
        <div className="lg:w-6/12 px-4 ml-auto">
          <div className="mb-3">
            <Breadcrumb routes={routes} />
          </div>
          {
            special &&
            <div className="rounded px-1 text-white text-xs mb-4 inline-block" style={{background: '#FF5448'}}>Special Resource</div>
          }
          <h1 className="text-2xl lg:text-4xl font-bold font-primary mb-4 lg:mb-8 leading-tight">{title}</h1>
          {
            organization &&
            <FormRow>
              <User name={organization}/>
            </FormRow>
          }
          {
            (expertise || email || phone) &&
            <div className="w-full flex flex-wrap -mx-2 lg:-mx-4 mb-1">
              {
                expertise &&
                <div className="w-full px-2 lg:px-4">
                  <Meta
                    className="mb-4 lg:mb-8"
                    label="Expertise"
                    value={expertise}
                  />
                </div>
              }
              {
                email &&
                <div className="w-1/2 lg:w-1/3 px-2 lg:px-4">
                  <Meta
                    className="mb-6 lg:mb-0"
                    label="Email"
                    value={email}
                  />
                </div>
              }
              {
                phone &&
                <div className="w-1/2 lg:w-1/3 px-2 lg:px-4">
                  <Meta
                    className="mb-6 lg:mb-0"
                    label="Phone"
                    value={phone}
                  />
                </div>
              }
            </div>
          }
          <hr className="my-6 lg:my-10" style={{ borderColor: '#ddd' }}/>
          <div className="prose text-gray-444 mb-8 lg:mb-10 text-sm" dangerouslySetInnerHTML={{__html: content}}>
          </div>

          {/* <ActionButtons /> */}

          <hr className="my-8 lg:my-10"/>
          <ShareButtons />
        </div>
      </div>
    </Container>
  )
}

export { TypeExpert }